const STORAGE_KEY = "tunnme_cookie_consent";
const CONSENT_VERSION = 1;
const GA_ID = "G-1KSXQ60BCR";
const HOTJAR = { hjid: 5032092, hjsv: 6 };

export function getCookieConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.version !== CONSENT_VERSION) return null;
    return data;
  } catch (_e) {
    return null;
  }
}

export function saveCookieConsent(analytics) {
  const payload = {
    version: CONSENT_VERSION,
    necessary: true,
    analytics: !!analytics,
    updated_at: new Date().toISOString()
  };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  return payload;
}

export function loadAnalyticsScripts() {
  if (window.__tunnmeAnalyticsLoaded) return;
  window.__tunnmeAnalyticsLoaded = true;

  const gtagScript = document.createElement("script");
  gtagScript.async = true;
  gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(gtagScript);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID);

  (function hotjar(h, o, t, j, a, r) {
    h.hj =
      h.hj ||
      function hj() {
        (h.hj.q = h.hj.q || []).push(arguments);
      };
    h._hjSettings = { hjid: HOTJAR.hjid, hjsv: HOTJAR.hjsv };
    a = o.getElementsByTagName("head")[0];
    r = o.createElement("script");
    r.async = 1;
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
    a.appendChild(r);
  })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");
}

function hideBanner(banner) {
  if (banner) banner.hidden = true;
}

function showBanner(banner) {
  if (banner) banner.hidden = false;
}

function bindCookieConsent() {
  const banner = document.getElementById("cookie-consent-banner");
  if (!banner || banner.dataset.bound === "true") return;
  banner.dataset.bound = "true";

  const customizePanel = document.getElementById("cookie-consent-customize");
  const analyticsCheckbox = document.getElementById("cookie-consent-analytics");

  const acceptBtn = document.getElementById("cookie-consent-accept");
  const rejectBtn = document.getElementById("cookie-consent-reject");
  const customizeBtn = document.getElementById("cookie-consent-customize-toggle");
  const saveBtn = document.getElementById("cookie-consent-save");

  function applyConsent(analytics) {
    saveCookieConsent(analytics);
    hideBanner(banner);
    if (customizePanel) customizePanel.hidden = true;
    if (analytics) loadAnalyticsScripts();
  }

  if (acceptBtn) {
    acceptBtn.addEventListener("click", function () {
      applyConsent(true);
    });
  }

  if (rejectBtn) {
    rejectBtn.addEventListener("click", function () {
      applyConsent(false);
    });
  }

  if (customizeBtn && customizePanel) {
    customizeBtn.addEventListener("click", function () {
      customizePanel.hidden = !customizePanel.hidden;
    });
  }

  if (saveBtn) {
    saveBtn.addEventListener("click", function () {
      const analytics = analyticsCheckbox ? analyticsCheckbox.checked : false;
      applyConsent(analytics);
    });
  }

  const existing = getCookieConsent();
  if (existing) {
    hideBanner(banner);
    if (existing.analytics) loadAnalyticsScripts();
  } else {
    showBanner(banner);
  }
}

document.addEventListener("DOMContentLoaded", bindCookieConsent);
document.addEventListener("turbolinks:load", bindCookieConsent);
